export default __webpack_public_path__ + "static/integrated-calendar-a10e0c4e34522e8785d588bc911145d0.webp";